/** Notices.jsx - the empty/error bands and the sheet footer. */
import { AMBER_BAND, AMBER_MARK, AMBER_TEXT, GREY, GREY_LIGHT, INK_SOFT, LABEL, RULE } from './theme';

export function Notice({ label, children }) {
  return (
    <div style={{ paddingTop: 18 }}>
      {label ? <div style={LABEL}>{label}</div> : null}
      <p
        style={{
          margin: label ? '9px 0 0' : 0,
          fontSize: 13,
          color: INK_SOFT,
          lineHeight: 1.65,
          maxWidth: 470,
        }}
      >
        {children}
      </p>
    </div>
  );
}

export function ErrorBand({ onRetry }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        flexWrap: 'wrap',
        marginTop: 15,
        padding: '8px 11px',
        background: AMBER_BAND,
        borderTop: '1px solid ' + AMBER_MARK,
        borderBottom: '1px solid ' + AMBER_MARK,
      }}
    >
      <span style={{ fontSize: 11.5, fontWeight: 700, color: AMBER_TEXT, letterSpacing: '0.3px' }}>
        Could not refresh just now. Showing the last recorded status.
      </span>
      <button
        type="button"
        onClick={onRetry}
        style={{
          border: '1px solid ' + AMBER_MARK,
          background: 'transparent',
          color: AMBER_TEXT,
          borderRadius: 0,
          padding: '7px 18px',
          minHeight: 32,
          fontSize: 9.5,
          fontWeight: 800,
          letterSpacing: '1.6px',
          textTransform: 'uppercase',
          cursor: 'pointer',
          fontFamily: 'inherit',
        }}
      >
        Retry
      </button>
    </div>
  );
}

export function Footer({ stamp }) {
  return (
    <footer style={{ marginTop: 32 }}>
      <div style={{ height: 1, background: RULE }} />
      <div className="svm-foot" style={{ paddingTop: 11 }}>
        <p
          style={{
            margin: 0,
            maxWidth: 520,
            fontSize: 10,
            color: GREY,
            lineHeight: 1.65,
            letterSpacing: '0.25px',
          }}
        >
          GLOBAL Automation Technologies - System Verification status. Questions: contact your GLOBAL project manager.
        </p>
        <span
          style={{
            fontSize: 8.5,
            fontWeight: 800,
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            color: GREY_LIGHT,
            whiteSpace: 'nowrap',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          Page generated {stamp}
        </span>
      </div>
    </footer>
  );
}
